import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/curriculum/Curriculum.tsx");
